import { Building2 } from 'lucide-react'

import { api } from '@/api/client'
import type { PartnerGroup } from '@/types/models'
import { ListPickerModal } from './ListPickerModal'

interface Props {
  value: number | null
  onChange: (g: PartnerGroup) => void
  placeholder?: string
}

export function GroupPicker({
  value, onChange, placeholder = '상위 거래처 선택...',
}: Props) {
  return (
    <ListPickerModal<PartnerGroup>
      value={value}
      onChange={onChange}
      title="상위 거래처 선택"
      triggerPlaceholder={placeholder}
      searchPlaceholder="상위 이름, 사업자번호"
      triggerIcon={<Building2 className="w-3.5 h-3.5 text-slate-400 shrink-0"/>}
      queryKey={['partner-groups-picker']}
      fetchDetail={(id) => api<PartnerGroup>(`/api/partner-groups/${id}`)}
      fetchList={(q) => {
        const params = new URLSearchParams()
        if (q) params.set('q', q)
        return api<PartnerGroup[]>(`/api/partner-groups?${params}`)
      }}
      formatLabel={(g) => `${g.name} · ${g.member_count}개`}
      renderRow={(g) => (
        <>
          <div className="flex items-center gap-2">
            <Building2 className="w-3.5 h-3.5 text-slate-400"/>
            <span className="font-medium">{g.name}</span>
            <span className="ml-auto text-xs text-slate-500 tabular-nums">{g.member_count}개 자식</span>
          </div>
          {g.biz_no && (
            <div className="text-xs text-slate-400 tabular-nums mt-0.5 ml-6">{g.biz_no}</div>
          )}
        </>
      )}
    />
  )
}
